import {
  ACTION_GET_ORG_EXPENSE_REPORTS,
  ACTION_GET_ORG_EXPENSE_REPORTS_SUCCESS,
  ACTION_GET_ORG_EXPENSE_REPORTS_FAILURE,
  ACTION_GET_MORE_ORG_EXPENSE_REPORTS,
  ACTION_GET_MORE_ORG_EXPENSE_REPORTS_SUCCESS,
  ACTION_GET_MORE_ORG_EXPENSE_REPORTS_FAILURE,
  ACTION_EMPTY_ORG_EXPENSE_REPORTS,
  ACTION_EDIT_EXPENSE_REPORT,
  ACTION_EDIT_EXPENSE_REPORT_SUCCESS,
  ACTION_EDIT_EXPENSE_REPORT_FAILURE,
} from '../configs/ActionTypes';

import { ExpenseReport, Cursor } from '../components/CompanyDetails/expenseTypes';

export type OrgExpenseReportsState = {
  expenseReports: ExpenseReport[];
  isLoading: boolean;
  isLoadingMore: boolean;
  hasMore: boolean;
  cursor: Cursor | null;
  success: boolean | null;
};

const initialState: OrgExpenseReportsState = {
  expenseReports: [],
  isLoading: false,
  isLoadingMore: false,
  hasMore: true,
  cursor: null,
  success: null,
};

export default function (state = initialState, action: any) {
  switch (action.type) {
    case ACTION_GET_ORG_EXPENSE_REPORTS: {
      return { ...state, isLoading: true, success: null };
    }

    case ACTION_GET_ORG_EXPENSE_REPORTS_SUCCESS: {
      const responsePayload = action.payload?.payload;
      const expenseReports = Array.isArray(responsePayload)
        ? responsePayload
        : responsePayload?.data ?? [];
      const cursor = Array.isArray(responsePayload)
        ? null
        : responsePayload?.cursor;
      const resolvedCursor = cursor ?? null;
      return {
        ...state,
        isLoading: false,
        expenseReports,
        cursor: resolvedCursor,
        hasMore: resolvedCursor !== null,
        success: null,
      };
    }

    case ACTION_GET_ORG_EXPENSE_REPORTS_FAILURE: {
      return { ...state, isLoading: false, success: false };
    }

    case ACTION_GET_MORE_ORG_EXPENSE_REPORTS: {
      return { ...state, isLoadingMore: true };
    }

    case ACTION_GET_MORE_ORG_EXPENSE_REPORTS_SUCCESS: {
      const { data, cursor } = action.payload?.payload ?? {};
      const resolvedCursor = cursor ?? null;
      return {
        ...state,
        isLoadingMore: false,
        expenseReports: [...state.expenseReports, ...(data || [])],
        cursor: resolvedCursor,
        hasMore: resolvedCursor !== null,
      };
    }

    case ACTION_GET_MORE_ORG_EXPENSE_REPORTS_FAILURE: {
      return { ...state, isLoadingMore: false };
    }

    case ACTION_EDIT_EXPENSE_REPORT: {
      return { ...state, isLoading: true, success: null };
    }

    case ACTION_EDIT_EXPENSE_REPORT_SUCCESS: {
      const updatedReports: ExpenseReport[] = action.payload?.payload ?? [];
      const updatedMap = new Map(
        updatedReports.map((r) => [r.id, r]),
      );
      const expenseReports = updatedMap.size > 0
        ? state.expenseReports.map((r) =>
            updatedMap.has(r.id) ? { ...r, ...updatedMap.get(r.id) } : r,
          )
        : state.expenseReports;

      return {
        ...state,
        expenseReports,
        isLoading: false,
        success: true,
      };
    }

    case ACTION_EDIT_EXPENSE_REPORT_FAILURE: {
      return { ...state, isLoading: false, success: false };
    }

    case ACTION_EMPTY_ORG_EXPENSE_REPORTS: {
      return initialState;
    }

    default: {
      return state;
    }
  }
}
